export * from "./utility-functions";
export const urlRegex = "^(?:https:\/\/)+";
export const hexRegex = "^#(?=[a-f0-9]*$)(?:.{3}|.{6})$";
export const domainRegex = "^[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$";
export const UK = "United Kingdom";